import React, { Component } from "react";
import "./styles/badge.css";

class BadgeContainer extends Component {
  render() {
    return (
      <div className="d-flex flex-row flex-wrap badge-row">{this.props.children}</div>
    );
  }
}

export default BadgeContainer;
